module.exports = __webpack_public_path__ + "static/media/business-lunch-hero.df4a8e6e.jpg";